<script setup>
  import { computed } from 'vue'

  const props = defineProps({
    value: { type: Number, default: 0 },
    variant: { type: String, default: 'thin' }, // 'thin' | 'thick'
    color: { type: String, default: 'success' }
  })

  const clamped = computed(() => Math.min(Math.max(props.value, 0), 100))
  const isComplete = computed(() => clamped.value >= 100)
</script>

<template>
  <div
    class="progress"
    :class="[
      variant === 'thick' ? 'bcs-progress-thick' : 'bcs-progress-thin',
      isComplete ? 'bcs-track-complete' : 'bcs-track-incomplete'
    ]"
    role="progressbar"
    :aria-valuenow="clamped"
    aria-valuemin="0"
    aria-valuemax="100">
    <div class="progress-bar" :class="`bg-${color}`" :style="{ width: `${clamped}%` }"></div>
  </div>
</template>

<style scoped>
  .bcs-progress-thin {
    height: 9px;
  }
  .bcs-progress-thick {
    height: 22px;
  }

  /* Figma: complete → gray track; incomplete → white track + inset border.
   inset box-shadow draws OVER the fill (not around it), so the green fill
   never bleeds into the border visually. */
  .bcs-track-complete {
    background-color: #e9ecef;
  }
  .bcs-track-incomplete {
    background-color: #fff;
    box-shadow: inset 0 0 0 1px #c5cdd4;
  }
</style>
